var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":"plus"}}),_c('span',{staticStyle:{"margin-right":"0.5em"}}),_c('a',[_vm._v("もう一つリストを追加")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }